var _defs, _g;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgFullscreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "vowltyohwa"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.650000 0 0 0 0 0.650000 0 0 0 0 0.650000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#a6a6a6",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "",
    transform: "translate(-181.000000, -542.000000) translate(-2.000000, 0.000000) translate(1.000000, 463.000000) translate(20.000000, 79.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "#a6a6a6",
    strokeWidth: 1.5,
    transform: "translate(162.000000, 0.000000) translate(3.250000, 3.250000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.813 6.906V2.031c0-.673.545-1.219 1.218-1.219h4.875M19.094 6.906V2.031c0-.673-.546-1.219-1.219-1.219H13M.813 13v4.875c0 .673.545 1.219 1.218 1.219h4.875M19.094 13v4.875c0 .673-.546 1.219-1.219 1.219H13"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.969,
    height: 10.969,
    x: 4.469,
    y: 4.469,
    rx: 1.5
  }))))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreen);
export default __webpack_public_path__ + "static/media/Fullscreen.cf4897a1.svg";
export { ForwardRef as ReactComponent };